import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=1efddff5&scoped=true"
import script from "./ResultsPage.vue?vue&type=script&lang=ts"
export * from "./ResultsPage.vue?vue&type=script&lang=ts"
import style0 from "./ResultsPage.vue?vue&type=style&index=0&id=1efddff5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efddff5",
  null
  
)

export default component.exports